import { useEffect } from "react"
import {
  addPaymentPreprocessor,
  removePaymentPreprocessor,
} from "aldoo-ra/Store/api"

const IMPACT_STORAGE_KEY = "impact_click_id"
const IMPACT_PREPROCESSOR_ID = "impact_tracking"
const EXPIRATION_DAYS = 30

export default function Impact() {
  useEffect(() => {
    // Get Click ID from URL
    const getClickIdFromUrl = () => {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get("im_ref")
    }

    // Save Click ID to localStorage with timestamp
    const saveClickId = (clickId) => {
      const data = {
        timestamp: Date.now(),
        value: clickId,
      }
      localStorage.setItem(IMPACT_STORAGE_KEY, JSON.stringify(data))
    }

    // Get Click ID from localStorage if not expired
    const getStoredClickId = () => {
      try {
        const stored = localStorage.getItem(IMPACT_STORAGE_KEY)
        if (!stored) return null

        const data = JSON.parse(stored)
        const now = Date.now()
        const expirationMs = EXPIRATION_DAYS * 24 * 60 * 60 * 1000

        // Check if expired
        if (now - data.timestamp > expirationMs) {
          localStorage.removeItem(IMPACT_STORAGE_KEY)
          return null
        }

        return data.value
      } catch (error) {
        console.error("Error reading impact_click_id from localStorage:", error)
        return null
      }
    }

    // Check URL and save Click ID if present
    const checkAndSaveClickId = () => {
      const clickId = getClickIdFromUrl()
      if (clickId) {
        saveClickId(clickId)
      }
    }

    // Check on mount
    checkAndSaveClickId()

    // Listen for URL changes (for SPA navigation)
    const handleUrlChange = () => {
      checkAndSaveClickId()
    }

    // Listen to popstate (browser back/forward)
    window.addEventListener("popstate", handleUrlChange)

    // Intercept pushState and replaceState for SPA navigation
    const originalPushState = window.history.pushState
    const originalReplaceState = window.history.replaceState

    window.history.pushState = function (...args) {
      originalPushState.apply(this, args)
      handleUrlChange()
    }

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(this, args)
      handleUrlChange()
    }

    // Register payment preprocessor
    addPaymentPreprocessor({
      id: IMPACT_PREPROCESSOR_ID,
      action: (paymentData) => {
        const clickId = getStoredClickId()
        if (!clickId) return paymentData
        return {
          ...paymentData,
          impact_click_id: clickId,
        }
      },
    })

    // Cleanup on unmount
    return () => {
      window.removeEventListener("popstate", handleUrlChange)
      window.history.pushState = originalPushState
      window.history.replaceState = originalReplaceState
      removePaymentPreprocessor(IMPACT_PREPROCESSOR_ID)
    }
  }, [])

  return null
}
